module.exports = __webpack_public_path__ + "static/img/1.c0e96037.jpeg";